import { defineMessages } from 'react-intl';

const messages = defineMessages({
  stepTitle: {
    id: 'registration.address.stepTitle',
    defaultMessage: 'Address',
    description: 'Registration address step title',
  },
  title: {
    id: 'registration.address.title',
    defaultMessage: 'Address',
    description: 'Registration address title',
  },
  description: {
    id: 'registration.address.description',
    defaultMessage: 'Please enter your address.',
    description: 'Registration address description',
  },
  alphanumericValidation: {
    id: 'general.alphanumericValidation',
    defaultMessage: 'Please only use alphanumeric characters.',
    description: 'Alphanumeric validation',
  },
  alphaCharactersValidation: {
    id: 'general.alphaCharactersValidation',
    defaultMessage: 'Please use alphabetic characters.',
    description: 'Alpha characters validation',
  },
});

export default messages;
